import React from 'react';
import { compose, withState, withPropsOnChange, withHandlers } from 'recompose';
import format from 'date-fns/format';
import AutoSuggest from './AirportAutoSuggest';
import { Div, Flex, Span } from './hocs/withStyles';
import sunnySVG from '../svgs/weather/Sunny.svg';

const Home = compose(
  withState(
    'airportInput',
    'setAirportInput',
    props => (props.searches[0] && props.searches[0].origin) || ''
  ),
  withState(
    'newOrigin',
    'setNewOrigin',
    props =>
      // take last search or current origin
      props.searches[0] && props.searches[0].origin
        ? { code: props.searches[0].origin }
        : null
  ),
  withState('newOneWay', 'setNewOneWay', props => props.oneWay),
  withState('formIsValid', 'setValid', true),
  withPropsOnChange(['departureDate', 'returnDate'], ({ departureDate, returnDate }) => {
    return {
      depDay: format(departureDate, 'dddd'),
      retDay: format(returnDate, 'dddd')
    };
  }),
  withHandlers({
    onDepDate: ({ dates, departureDate, setDepartureDate }) => () => {
      const i = dates.findIndex(date => date === departureDate);
      const newDate = i > 2 ? dates[i - 1] : dates[i + 1];
      setDepartureDate(newDate);
    },
    onRetDate: ({ dates, returnDate, setReturnDate }) => () => {
      const i = dates.findIndex(date => date === returnDate);
      const newDate = i > 5 ? dates[i - 1] : dates[i + 1];
      setReturnDate(newDate);
    },
    changeOrigin: props => () => {
      const { newOrigin } = props;
      if (!newOrigin) return;
      const { countryId, name, code } = newOrigin;
      props.setOriginName(name || '');
      // set market and units based on origin
      props.setOriginCountryId(countryId || 'ES');
      props.setDegreeUnit(countryId === 'US' ? 'F' : 'C');
      props.setCurrency(countryId === 'UK' ? 'GBP' : countryId === 'US' ? 'USD' : 'EUR');
      // track last search
      props.setSearches([{ origin: code }]);
    }
  }),
  withHandlers({
    onSubmit: props => () => {
      const { newOrigin } = props;
      if (!newOrigin) return props.setValid(false);
      props.changeOrigin(newOrigin);
      window.location.hash = `/from/${newOrigin.code}`;
    }
  })
)(props => {
  const { depDay, retDay } = props;
  return (
    <Flex css={styles.container}>
      <Div p={[0, 1]}>
        <Div css={styles.sunContainer}>
          <img src={sunnySVG} width="100%" alt="sun" />
        </Div>
        <Div css={styles.headline}>
          <h1 style={styles.header}>Let's Have Some Sun!</h1>
        </Div>
        <Div color="white" css={styles.intro}>
          I want to leave{' '}
          <Span onClick={props.onDepDate} css={styles.toggle}>
            {depDay}
          </Span>
          <br />
          and return{' '}
          <Span css={styles.toggle} onClick={props.onRetDate}>
            {retDay}
          </Span>
        </Div>
      </Div>
      <Div css={styles.inputs}>
        <Div>
          <AutoSuggest {...props} />
        </Div>
        <Div css={styles.button} p={[2, 0]} onClick={props.onSubmit}>
          Show Destinations
        </Div>
      </Div>
    </Flex>
  );
});

export default Home;

const smQuery = '@media (max-height: 600px)';

const styles = {
  container: {
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '72vh',
    zIndex: '10',
    '@media (orientation: portrait)': {
      height: '85vh'
    },
    [smQuery]: {
      height: '90vh'
    }
  },
  sunContainer: {
    width: '120px',
    paddingTop: '50px',
    margin: '0 auto',
    [smQuery]: {
      width: '60px',
      paddingTop: '30px'
    }
  },
  headline: {
    textAlign: 'center',
    fontSize: '28px',
    // border: '1px solid red',
    [smQuery]: {
      fontSize: '18px'
    },
    '@media (orientation: portrait)': {
      fontSize: '16px'
    }
  },
  header: {
    color: 'white',
    padding: '0.3em 0 0.1em 0',
    margin: 0,
    fontWeight: 'normal'
  },
  intro: {
    fontSize: '1.1em',
    textAlign: 'center',
    lineHeight: 1.8,
    [smQuery]: {
      fontSize: '0.9em'
    }
  },
  toggle: {
    borderBottom: '2px dotted #FFEC65',
    color: '#FFEC65',
    fontSize: '1.2em',
    ':hover': {
      cursor: 'pointer',
      opacity: '0.6'
    }
  },
  inputs: {
    width: '40%',
    '@media (orientation: portrait)': {
      width: '90%'
    }
  },
  button: {
    backgroundColor: '#FFEC65',
    textAlign: 'center',
    ':hover': {
      cursor: 'pointer',
      opacity: '0.6'
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Home.js